var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{class:{
    'media': this.status === 'video',
    'media--hidden': this.status !== 'video',
    'media--orientation-landscape': this.status === 'video' && this.orientation === 'landscape',
    'media--orientation-portrait': this.status === 'video' && this.orientation === 'portrait',
    'media--orientation-unknown': this.status === 'video' && this.orientation === 'unknown',
  },attrs:{"autoplay":"","playsinline":""},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }